import { CoreMobiResource } from '@bepatient/core';
import { TimelineActivityRecurrence } from '@bepatient/shared';

/**
 * Objet de base de la timeline
 */
export interface Timeline {
  /**
   *  List of timeline activities, see {@link TimelineDay}
   */
  days: Array<TimelineDay>;
  /**
   * List of timeline info messages, see {@link TimelineInfoMessage}
   */
  infoMessages: Array<TimelineInfoMessage>;
  /**
   * List of blocking activities of the timeline in order
   */
  blockers?: Array<TimelineBlocker>;
  /**
   * List of timeline notifications, see {@link TimelineActivityRecurrence}
   */
  rrules_info?: Array<TimelineActivityRecurrence>;
}

export interface TimelineBlocker {
  activity?: TimelineActivity;
  infoMessage?: TimelineInfoMessage;
}

/**
 * Objet journée de la timeline
 */
export interface TimelineDay {
  /**
   * Date de la journée
   */
  date: string;
  /**
   * Sous-date de la journée
   */
  subDate: string;
  /**
   * Un tableau contenant la liste des activités de la journée, voir {@link TimelineActivity}
   */
  activities: Array<TimelineActivity>;
}

/**
 * Object activité d'une journée de la timeline
 */
export interface TimelineActivity {
  /**
   * Activity uuid
   */
  uuid?: string;
  /**
   * Couleur de l'activité
   */
  color: string;
  /**
   * Titre de l'activité
   */
  title: string;
  /**
   * Image de l'activité
   */
  image: string;
  /**
   * Message de l'activité
   */
  message: string;
  /**
   * Si l'activité est bloquante, `blocking` défini la priorité de l'activité bloquante
   */
  blocking: number;
  /**
   * Progression de l'activité, de 0 à 1
   */
  progress: number;
  /**
   * Resource de l'activité, voir {@link CoreMobiResource} dans `CoreModule`
   */
  resource: CoreMobiResource;
  /**
   * Activity Icon
   */
  icon?: string;
  /**
   * RRule
   */
  rrules?: TimelineActivityRecurrence;
  /**
   * Activity Occurrence
   */
  occurrence?: number;
}

/**
 * Objet de message d'info de la timeline
 */
export interface TimelineInfoMessage {
  /**
   * uuid du message d'info
   */
  uuid: string;
  /**
   * href du message d'info
   */
  href: string;
  /**
   * Couleur du message d'info
   */
  color: string;
  /**
   * Contenu du message d'info
   */
  content: string;
  /**
   * Titre du bouton du message d'info
   */
  buttonLabel: string;
  /**
   * Si le message d'info est bloquant, `blocking` défini la priorité du message d'info bloquant
   */
  blocking: number;
  /**
   * Est-ce que le bouton du message d'info doit être visible ou non
   */
  showButton: boolean;
  /**
   * Activity resource, see {@link CoreMobiResource} in `CoreModule`
   */
  resource?: CoreMobiResource;
  /**
   * Info Message Icon
   */
  icon?: string;
}
